import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import TGApi from 'lib/webapp-api';
import useBoundStore from 'store';

const HomeScreensWrapper: React.FC = () => {
  const isAuth = useBoundStore((s) => s.authToken);

  useEffect(() => {
    TGApi.expand();
    if (!isAuth) {
      useBoundStore.getState().openAuthBottomSheet();
    }
  }, [isAuth]);

  if (!isAuth) {
    return <></>;
  }

  return <Outlet />;
};

export default HomeScreensWrapper;
